import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';
import { isRumEnabled } from './constants/environments';

export const configureDataDog = () => {
  const { hostname } = window.location;
  const hostnameEnvMap: Record<string, string> = {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'uat-arbor.trellisrx.com': 'uat',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'staging-arbor.trellisrx.com': 'staging',
    // eslint-disable-next-line @typescript-eslint/naming-convention
    'arbor.trellisrx.com': 'prod',
  };
  const env = hostnameEnvMap[hostname];

  // Check if RUM should be enabled for this environment
  if (!isRumEnabled(env)) {
    console.info(`[Datadog] RUM disabled for environment: ${env || 'unknown'}`);
    return;
  }

  const defaultOptions: Partial<RumInitConfiguration> & { enableSessionReplayRecording: boolean } =
    {
      sessionSampleRate: 100,
      sessionReplaySampleRate: 100,
      trackUserInteractions: true,
      trackResources: true,
      trackLongTasks: true,
      defaultPrivacyLevel: 'mask',
      enableSessionReplayRecording: true,
    };
  const envOptions: Record<
    string,
    Partial<RumInitConfiguration> & { enableSessionReplayRecording: boolean }
  > = {
    uat: {
      ...defaultOptions,
      defaultPrivacyLevel: 'allow',
    },
  };

  if (env) {
    const { enableSessionReplayRecording, ...options } = envOptions[env] || defaultOptions;
    datadogRum.init({
      applicationId: '731c86bb-04ed-4444-b04f-304d2eb5b0d3',
      clientToken: 'pub0b48a48924d18e8b0032efca99322760',
      site: 'datadoghq.com',
      service: 'tcms-ui',
      env,
      version: '7254d09497f37667e0f4415872711819188358f4',
      allowedTracingUrls: [/^https:\/\/.*\.trellisrx\.com$/],
      ...options,
    });

    if (enableSessionReplayRecording) {
      datadogRum.startSessionReplayRecording();
    }
  }
};
